import React from 'react'
import { dateConvert, RenderSignatureField } from '../../utils/Helper'
import { useCommanKit } from '../../Hooks/Features/WelcomeKit/useCommanKit'
import { useLeaveTravel } from '../../Hooks/Features/WelcomeKit/useLeaveTravel';

const LeaveTravel = ({ data, onPrev, onNext, readOnly }) => {
    const { signature, handleChange, handleRemove } = useCommanKit({ data });
    const { option, handleSubmit, selectedOption, setSelectedOption, setIsChanged, date } = useLeaveTravel({ data, onNext });


    return (
        <div className='my-2'>
            <h4 style={{ backgroundColor: '#f2f2f2', padding: '0.5rem 1rem' }}>Leave Travel Allowance</h4>
            <section className="py-2" aria-label="Joining letter introduction">
                <p>To,</p>
                <strong>The Head HR</strong>
                <p className="my-2">
                    SRKAY Consulting Group Pvt. Ltd.<br />
                    {data?.commonDetails?.job_location}
                </p>
                <p>Employee ID : <b>{data?.employee?.employee_id}</b></p>

            </section>
            <section>
                <h5 className='text-center my-2'>Declaration for exercising the option of claiming Leave Travel Allowance</h5>
                <div>A. As per Human Resources Policy I, <strong>{data?.employee?.user_display_name}</strong> hereby request you to consider me for the payment / reimbursement of ‘Leave - Travel Allowance’</div>
                <div>
                    <div className='d-flex'>
                        B. I hereby exercise the following:
                        {
                            option?.map((val) => {
                                return <label key={val.value} className='bold'>
                                    <input
                                        type='radio'
                                        name="leave"
                                        checked={selectedOption === val.value}
                                        value={val.value}
                                        onChange={(e) => { setSelectedOption(val.value); setIsChanged(true) }}
                                    />
                                    {val?.label}
                                </label>
                            })
                        }
                    </div>
                </div>
                <p className="mt-2">
                    <span className="bold">Option 1:</span>
                    The amount of Leave Travel Allowance for the block of {date?.blockText} be paid to me on a monthly basis, net of applicable taxes.
                </p>

                <p className="mt-2">
                    <span className="bold">Option 2:</span>
                    I will claim the Leave Travel Allowance for the block of {date?.blockText}, on a reimbursement basis and I will not avail it in monthly salary on a pro-rata basis.
                    I will submit the declaration/supporting documents for the period at the end of F.Y. {date?.endYearOnly}.
                    In case the actual eligible expenses incurred are less than my entitlement, then the balance if any may be paid to me at the end of the said block after deducting the tax at source.
                </p>

                <p className='my-4'>I hereby confirm that the above information contained here in above is true to the best of my knowledge and belief.</p>
                <p className="mt-2">Employee Signature</p>
                <div className='d-flex justify-content-between'>
                    <div>
                        {
                            !readOnly && <RenderSignatureField
                                name="user_signature_url"
                                handleChange={handleChange}
                                value={signature}
                                handleRemove={handleRemove}
                            />
                        }

                    </div>
                    <div>
                        <p>Designation :<strong>{data?.employee?.user_category_name}</strong> </p>
                    </div>
                </div>
                <div className='d-flex justify-content-between my-1'>
                    <span>Place: {data?.commonDetails?.job_location} </span>
                    <span>Date: <strong>{dateConvert(data?.employee?.joining_date, 'day-mon-year')}</strong> </span>
                </div>
            </section>
            {
                !readOnly && <div className='d-flex gap-2 justify-content-end position-fixed w90 bottom-0 end-0 px-4 pb-2 bg-white'>
                    <button className="btn-default" type="button" onClick={onPrev}>Previous</button>
                    <button className="btn-primary" type="button" onClick={handleSubmit}>Save & Next</button>
                </div>
            }
        </div>
    );
};

export default LeaveTravel;
